import { Modal } from "@mantine/core";
import { CDN_URL } from "../../../constant";

const AudioSpotPopUp = ({
	isAudioSpotOpen,
	setIsAudioSpotOpen,
	audioSpotDetails,
}) => {
	return (
		<>
			<Modal
				centered
				size="lg"
				opened={isAudioSpotOpen}
				onClose={() => setIsAudioSpotOpen(false)}
				title={audioSpotDetails.text}
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
			>
				<audio controls>
					<source
						src={CDN_URL + audioSpotDetails.url}
						type="audio/mpeg"
					/>
					Your browser does not support the audio element.
				</audio>
			</Modal>
		</>
	);
};

export default AudioSpotPopUp;
